import React, { useCallback, useEffect, useRef, useState } from 'react';
import api from "../services/api";
import { setData, setResults, setListServicios, setListFiliales, setListTipos, setListModalidades } 
    from "../redux/invoiceItemSearchSlice";
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, TextField, Autocomplete, Button, Dialog, DialogActions
    , DialogContent, DialogTitle, Select, InputLabel, FormControl
    , CircularProgress, Hidden, Box } from '@mui/material';
import { DataGrid, GridToolbarContainer, GridToolbarExport, GridOverlay
    , GridToolbarFilterButton } from "@mui/x-data-grid";
import { Search as IconSearch } from "@mui/icons-material";
import { PaperComponentDraggable } from "./PaperComponentDraggable";

// const useStyles = makeStyles((theme) => ({
//     styleCircularProgress: {
//         display: 'flex',
//         '& > * + *': {
//             marginLeft: theme.spacing(2),
//         },
//     },
//     headerColor: {
//         "& .MuiDataGrid-columnHeader ": {
//             backgroundColor: "#1976d2",
//             color: "white"
//             }
//     }
// }));

const InvoiceItemSearch = (props) => {
    const filters = useSelector((state) => state.invoiceItemSearch.filters);
    const results = useSelector((state) => state.invoiceItemSearch.results);
    const listServicios = useSelector((state) => state.invoiceItemSearch.listServicios);
    const listFiliales = useSelector((state) => state.invoiceItemSearch.listFiliales);
    const listTipos = useSelector((state) => state.invoiceItemSearch.listTipos);
    const dispatch = useDispatch();
    const [selectItem, setSelectItem] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [servicioEnabled, setServicioEnabled] = useState(true);
    const [tipoEnabled, setTipoEnabled] = useState(true);
    const dialogRef = useRef()

    const fetchResults = async () => {
        setCargando(true);

        const response = await api.get('/Servicio/GetsConceptoCobroView?'
                + "idServicio=" + filters.idServicio
                + "&idFilial=" + filters.idFilial
                + "&idTipo=" + filters.idTipo
                + "&sesionesMes=" + filters.sesionesMes
                + "&idEstado=2"
                )
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });

        dispatch(setResults(response.data.data))
        setCargando(false);
    }
    
    const fetchServicios = useCallback(async () => {
        const response = await api.get("/Servicio/GetsListServicio")
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });

        dispatch(setListServicios(response.data.data));
        
    }, [])

    const fetchFiliales = useCallback(async () => {
        const response = await api.get("/Filial/GetsList")
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });

        dispatch(setListFiliales(response.data.data));
    }, [])

    const fetchTipos = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=49")
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });

        dispatch(setListTipos(response.data.data));
        
    }, [])

    useEffect(() => {
        fetchServicios();
        fetchFiliales();
        fetchTipos();
    }, [])

    useEffect(() => {
        dispatch(setData({name: "idServicio", value: props.idServicioSelect}))
        dispatch(setData({name: "idTipo", value: props.idTipoTerapiaSelect}))
        dispatch(setResults([]))
    }, [props])

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarFilterButton />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }

    function CustomLoadingOverlay() {
        return (
            <GridOverlay>
                <Box sx={{ display: "flex", "& > * + *": { ml: 2 } }}>
                    <CircularProgress />
                </Box>
            </GridOverlay>
        );
    }

    const columns = [
        { field: 'codigoFilial', headerName: 'Filial', width: 70, sortable: false },
        { field: 'codigo', headerName: 'Tarifa', width: 70, sortable: true },
        // { field: 'codigoServicio', headerName: 'Servicio', width: 70, sortable: false },
        { field: 'tipo', headerName: 'Tipo', width: 100, sortable: false },
        { field: 'descripcion', headerName: 'Descripcion', width: 250, sortable: true },
        { field: 'sesionesMes', headerName: 'Sesiones Mes', width: 100, sortable: false },
        { field: 'minutosSesion', headerName: 'Minutos Sesion', width: 100, sortable: false },
        { field: 'monto', headerName: 'Monto', width: 80, sortable: false },
    ];

    // setServicioEnabled(false)
    // setTipoEnabled(false)
    // setServicioEnabled(props.servicioEnabled)
    // setTipoEnabled(props.tipoEnabled)

    return (
        <Dialog
            open={props.open}
            onClose={props.openClose}
            fullWidth={true}
            maxWidth={"md"}
            PaperComponent={PaperComponentDraggable}
        >
            <DialogTitle
                id="draggable-dialog-title"
                style={{ cursor: "move" }}>
                <Typography>
                    Buscar Concepto de Cobro
                    {/* {JSON.stringify(filters)} */}
                </Typography>
            </DialogTitle>
            <DialogContent style={{ minHeight: "30px", maxHeight: "450px" }} >
                <Grid container item xs={12} sm={12} spacing={2} padding={1} >
                    <Grid item xs={12} sm={3}>
                        <FormControl required fullWidth>
                            <InputLabel htmlFor="input-servicio">Servicio</InputLabel>
                            <Select
                                native
                                // native={!listServicios.length == 0}
                                //defaultValue={0}
                                // disabled={!servicioEnabled}
                                label="Servicio"
                                value={filters.idServicio}
                                onChange={(event, newValue) => {
                                    dispatch(setData({name: "idServicio", value: event.target.value}))
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        event.preventDefault();
                                        fetchResults();
                                    }
                                }}
                                inputProps={{
                                    name: 'idServicio',
                                    id: 'input-servicio',
                                }}
                                size="small"
                            >
                                <option key={0} value={0}>{"(Todos)"}</option>
                                {listServicios.map((row) => (
                                    <option key={row.id} value={row.id}>{row.descripcion}</option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl required fullWidth>
                            <InputLabel htmlFor="input-tipo">Tipo</InputLabel>
                            <Select
                                native
                                // native={!listServicios.length == 0}
                                //defaultValue={0}
                                // disabled={!tipoEnabled}
                                label="Tipo"
                                value={filters.idTipo}
                                onChange={(event, newValue) => {
                                    dispatch(setData({name: "idTipo", value: event.target.value}))
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        event.preventDefault();
                                        fetchResults();
                                    }
                                }}
                                inputProps={{
                                    name: 'idTipo',
                                    id: 'input-tipo',
                                }}
                                size="small"
                            >
                                <option key={0} value={0}>{"(Todos)"}</option>
                                {listTipos.map((row) => (
                                    <option key={row.id} value={row.id}>{row.descripcion}</option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl required fullWidth>
                            <InputLabel htmlFor="input-filial">Filial</InputLabel>
                            <Select
                                native
                                // native={!listServicios.length == 0}
                                //defaultValue={0}
                                label="Filial"
                                value={filters.idFilial}
                                onChange={(event, newValue) => {
                                    dispatch(setData({name: "idFilial", value: event.target.value}))
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        event.preventDefault();
                                        fetchResults();
                                    }
                                }}
                                inputProps={{
                                    name: 'idFilial',
                                    id: 'input-filial',
                                }}
                                size="small"
                            >
                                <option key={0} value={0}>{"(Todos)"}</option>
                                {listFiliales.map((row) => (
                                    <option key={row.id} value={row.id}>{row.descripcion}</option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={8} sm={3}>
                        <TextField
                            // required
                            name="sesionesMes"
                            label="Sesiones Mes"
                            value={filters.sesionesMes}
                            fullWidth
                            onChange={(event) => {
                                dispatch(setData({name: "sesionesMes", value: event.target.value}))
                            }}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    fetchResults();
                                }
                            }}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={2} sm={2}>
                        <Button variant="outlined" onClick={() => {
                            fetchResults()
                        }}>
                            {<Hidden smDown>Buscar</Hidden>}
                            <IconSearch />
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <DataGrid
                            rows={results}
                            columns={columns}
                            initialState={{
                                pagination: {
                                paginationModel: {
                                    pageSize: 5,
                                },
                                },
                            }}
                            pageSize={5}
                            pageSizeOptions={[5]}
                            disableColumnMenu
                            components={{
                                Toolbar: CustomToolbar,
                                LoadingOverlay: CustomLoadingOverlay,
                            }}
                            loading={cargando}
                            rowHeight={25}
                            onRowSelectionModelChange={itm => setSelectItem(itm)}
                            // style={{ height: 250 }}
                            autoHeight={true}
                            // className={classes.headerColor}
                             sx={{
                                "& .MuiDataGrid-columnHeader": {
                                backgroundColor: "#1976d2",
                                color: "white",
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={() => {
                    if (selectItem.length > 0) {
                        const selectItems = results.filter(item => item.id === selectItem[0]);
                        props.setSelection(selectItems[0]);
                        props.openClose()
                    }
                }}>Aceptar</Button>
                <Button onClick={() => { props.openClose() }} >Cancelar</Button>
            </DialogActions>
        </Dialog>
    )
}

export default InvoiceItemSearch;
